import { alpha, Theme } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

// Delade kort-stilar för utskicks-wizardens steg (Medlemmar, Texter …) så alla steg ser likadana ut:
// 2px grå border som blir grön ton + grön kant när steget är klart-markerat. Ändra här = ändra överallt.

// Tidslinje-rad: kortet indraget till höger om en gemensam streckad vänsterlinje, med en ikon-nod på vänsterkanten.
// Mjuk övergång när raden låses upp/ned (opacity + gråskala) så flödet inte känns hackigt.
export const rowSx = { position: 'relative', pl: { xs: 6, sm: 7 }, mb: 2, transition: 'opacity .25s ease, filter .25s ease' } as const;

const nodeSx = {
  position: 'absolute',
  left: { xs: 2, sm: 6 },
  top: '50%',
  transform: 'translateY(-50%)',
  width: 36,
  height: 36,
  borderRadius: '50%',
  bgcolor: 'background.paper',
  border: '2px solid',
  borderColor: 'primary.main',
  color: 'primary.main',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
} as const;

// Kort-stil som matchar korten på steg 1 (Typ av utskick): grön ton + grön kant när steget är klart.
export const cardStyle = (done: boolean) => ({
  // Klart läge blir kompaktare (mindre padding) så de färdiga korten tar mindre höjd.
  p: done ? { xs: 1.5, sm: 2 } : { xs: 2, sm: 2.5 },
  position: 'relative' as const,
  borderRadius: 1.5,
  border: '2px solid',
  borderColor: done ? 'success.main' : 'divider',
  bgcolor: (theme: Theme) => (done ? alpha(theme.palette.success.light, 0.2) : theme.palette.background.paper),
  transition: 'border-color .15s, background-color .15s',
});

export const nodeStyle = (done: boolean) => ({
  ...nodeSx,
  borderColor: done ? 'success.main' : 'primary.main',
  color: done ? 'success.main' : 'primary.main',
});

// Lås/gråa ut ett kort tills föregående steg är bekräftat – tvingar användaren att svara i rätt ordning.
// Gråskala + nedtoning gör tydligt att kortet inte går att använda (även färgade loggor blir grå).
export const lockedSx = (locked: boolean) => (locked ? { opacity: 0.5, filter: 'grayscale(1)', pointerEvents: 'none' as const } : {});

// Grön bock uppe i högra hörnet på ett klart kort (samma indikator som steg 1-korten).
export const doneCheck = <CheckCircle sx={{ position: 'absolute', top: 8, right: 8, fontSize: 20, color: 'success.main' }} />;
